import { Transition } from '@headlessui/react';
import parse from 'html-react-parser';
import { useCallback, useEffect, useState } from 'react';

import { MetaTag } from '~components/generic/MetaTag/MetaTag';
import useLabels from '~hooks/useLabels';
import useTopics from '~hooks/useTopics';

type SubTopicSelectorProps = {
  topic: Topic;
  onTopicClick: (id: TopicId) => void;
  selectedTopicIds: Array<TopicId>;
};

export function SubTopicSelector({ topic, onTopicClick, selectedTopicIds }: SubTopicSelectorProps) {
  const { getTopicById } = useTopics();
  const [stateTopic, setStateTopic] = useState(topic);
  const { msgNewsfeedCustomizeRefine } = useLabels(['msgNewsfeedCustomizeRefine'], { topicName: stateTopic?.label });
  const getIsSelected = useCallback((id: TopicId) => selectedTopicIds.includes(id), [selectedTopicIds]);

  useEffect(() => {
    if (topic && topic.children.length > 0) {
      setStateTopic(topic);
    }
  }, [topic]);

  const show = (stateTopic && topic && stateTopic.id === topic.id) || false;
  const topics = stateTopic?.children.map(getTopicById) || [];

  return (
    <div className="absolute bottom-0 left-0 right-0">
      <Transition
        show={show}
        enter="ease-out duration-500 delay-200"
        enterFrom="opacity-0 h-0"
        enterTo="opacity-100 h-40"
        leave="ease-in duration-300 delay-200"
        leaveFrom="opacity-100 h-40"
        leaveTo="opacity-0 h-0"
      >
        <div className="relative">
          <div className="font-bold font-sm mt-1 mb-2">
            {!!msgNewsfeedCustomizeRefine && parse(msgNewsfeedCustomizeRefine)}
          </div>
          <div className="flex w-2/3 mx-auto flex-wrap justify-center pb-2">
            {topics.map(topic => {
              return (
                <MetaTag
                  key={topic.id}
                  color={topic.color}
                  className="m-1"
                  onClick={() => onTopicClick(topic.id)}
                  selected={getIsSelected(topic.id)}
                  label={topic.label}
                  child
                />
              );
            })}
          </div>
        </div>
      </Transition>
    </div>
  );
}
